import { createMuiTheme, colors } from "@material-ui/core";
import typography from "./typography";

const theme = createMuiTheme({
  palette: {
    background: {
      default: "#f7f9fb",
      paper: colors.common.white,
    },
    primary: {
      main: "#004e92",
      light: "#4c79c3",
      dark: "#002764",
    },
    secondary: {
      main: "#424b5f",
      dark: "#dee5ef",
      light: "#dee5ef",
    },
    text: {
      primary: "#424b5f",
      secondary: "#004e92",
    },
  },
  //@ts-ignore
  typography,
});

export default theme;
